import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as ProductsActions from './../actions/products.actions';
import { GetProducts } from './../actions/products.actions';
import { ProductsService } from '../../services/products.service';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TechnicalError, UserProduct } from '@dch/products-business-logic';

@Injectable({
  providedIn: 'root',
})
export class ProductsEffects {
  @Effect()
  products$: Observable<Action> = this.actions$.pipe(
    ofType(ProductsActions.GET_PRODUCTS),
    switchMap((action: GetProducts) =>
      this.productsService.getProducts(action.payload).pipe(
        map(
          (userProduct: UserProduct) =>
            new ProductsActions.GetProductsSuccess(userProduct),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new ProductsActions.GetProductsFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private productsService: ProductsService,
  ) {}
}
